import type React from 'react';
import { Wrapper } from './wrapper';

interface InfoBoxProps {
  tone?: 'info' | 'success' | 'warning' | 'error';
  limitHeight?: boolean;
  children: React.ReactNode | React.ReactNode[];
}

const InfoBox = ({ tone = 'info', limitHeight = false, children }: InfoBoxProps) => (
  <Wrapper $tone={tone} $limitHeight={limitHeight}>
    {children}
  </Wrapper>
);

export default InfoBox;
